import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import LoginCard from '../components/LoginCard';

const Login = () => {
  const navigate = useNavigate();

  const handleContactUsClick = () => {
    navigate('/support');
  };

  const handleAboutUsClick = () => {
    navigate('/about-us');
  };

  const handleBlogClick = () => {
    navigate('/blog');
  };

  return (
    <div className="login-page">
      {/* Background with animated elements */}
      <div className="background-container">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
          <div className="shape shape-5"></div>
          <div className="shape shape-6"></div>
        </div>
      </div>

      {/* Main content */}
      <div className="main-container">
        {/* Header */}
        <header className="header">
          <div className="header-content force-row-layout">
            <div className="logo-section">
              <div className="logo-container">
                <img src="/favicon.ico" alt="TabTrips" className="logo" />
                <div className="brand-text">
                  <h1 className="brand-title">
                    TabTrips <span className="brand-extranet">Extranet</span>
                  </h1>
                </div>
              </div>
            </div>
            
            <div className="header-actions">
              <button className="cta-button" onClick={handleContactUsClick}>
                <i className="fas fa-headset"></i>
                <span>Contact Us</span>
              </button>
              <button className="cta-button" onClick={() => navigate('/listing')}>
                <i className="fas fa-plus"></i>
                <span>Register Property</span>
              </button>
            </div>
          </div>
        </header>

        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-content">
            {/* Hero Content - Left side on desktop, second on mobile */}
            <div className="hero-text mobile-second">
              <h1 className="hero-title">
                Manage Your <span className="highlight">Properties</span> Like Never Before
              </h1>
              
              <p className="hero-description">
                Access your comprehensive property management dashboard. Monitor bookings, 
                update rates, and grow your business with our powerful OTA platform.
              </p>

              <div className="hero-stats">
                <div className="stat-item">
                  <div className="stat-number">Real-time</div>
                  <div className="stat-label">Booking Sync</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">24/7</div>
                  <div className="stat-label">Support Available</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">20+</div>
                  <div className="stat-label">Channel Managers Connectivity</div>
                </div>
              </div>

              <div className="feature-highlights">
                <div className="feature-item">
                  <i className="fas fa-chart-line"></i>
                  <span>Real-time Analytics</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-shield-alt"></i>
                  <span>Secure Platform</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-headset"></i>
                  <span>24/7 Support</span>
                </div>
              </div>

              {/* Support Information - Mobile Only */}
              <div className="support-info-mobile">
                <h3 className="support-title">Need Help?</h3>
                <div className="support-details">
                  <div className="support-item">
                    <i className="fas fa-phone"></i>
                    <div className="support-text">
                      <span className="support-label">Phone</span>
                      <span className="support-value">+91 7082828181</span>
                    </div>
                  </div>
                  <div className="support-item">
                    <i className="fas fa-envelope"></i>
                    <div className="support-text">
                      <span className="support-label">Email</span>
                      <span className="support-value">support@tabtrips.com</span>
                    </div>
                  </div>
                  <div className="support-item">
                    <i className="fas fa-clock"></i>
                    <div className="support-text">
                      <span className="support-label">Support Hours</span>
                      <span className="support-value">24/7 Available</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Login Form - Right side on desktop, first on mobile */}
            <div className="login-section mobile-first">
              {/* Mobile only welcome text */}
              <div className="mobile-welcome-badge">
                <i className="fas fa-rocket"></i>
                <span>Welcome to TabTrips Extranet</span>
              </div>
              
              {/* Mobile only hero title */}
              <h1 className="mobile-hero-title">
                Manage Your <span className="highlight">Properties</span> Like Never Before
              </h1>

              <LoginCard />
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="footer-content">
            <div className="footer-links">
              <a onClick={handleBlogClick} className="footer-link" style={{ cursor: 'pointer' }}>Blog</a>
              <a onClick={handleAboutUsClick} className="footer-link" style={{ cursor: 'pointer' }}>About Us</a>
              {/* <a onClick={handleContactUsClick} className="footer-link" style={{ cursor: 'pointer' }}>Contact Us</a> */}
              <a onClick={handleContactUsClick} className="footer-link" style={{ cursor: 'pointer' }}>Support</a>
              <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
              <a href="/terms-conditions" className="footer-link">Terms & Conditions</a>
            </div>
            <div className="footer-copyright">
              © 2024 TabTrips. All rights reserved.
            </div>
          </div>
        </footer>
      </div>

    </div>
  );
};

export default Login; 